import BaseExcelService from './BaseExcelService';

class ProtocoloExcelService extends BaseExcelService {
  getBaseUrl() {
    return '~/api/excel/Protocolo';
  }
}

export default new ProtocoloExcelService();
